import { Theme } from "@mui/material/styles";

export const sxCutText = {
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

export const iconWarningSx = (theme: Theme) => ({
  color: theme.colorSchemes.dark?.palette.warning.main,
});

export const iconErrorSx = (theme: Theme) => ({
  color: theme.colorSchemes.dark?.palette.error.main,
});

export const iconDefaultSx = (theme: Theme) => ({
  color: theme.colorSchemes.dark?.palette.action.active,
});
